import { render } from "./FormFormModal.vue?vue&type=template&id=125a53ce&scoped=true"
import script from "./FormFormModal.vue?vue&type=script&lang=ts"
export * from "./FormFormModal.vue?vue&type=script&lang=ts"

import "./FormFormModal.vue?vue&type=style&index=0&id=125a53ce&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-125a53ce"

export default script
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QToolbar,QToolbarTitle,QBtn,QCardSection,QForm,QInput,QBtnGroup,QSpace});
